import { Construction, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ComingSoonProps {
  featureName: string;
  description?: string;
}

export default function ComingSoon({ featureName, description }: ComingSoonProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 py-12 text-center">
      <div className="p-4 rounded-full bg-muted mb-6">
        <Construction className="h-10 w-10 text-muted-foreground" />
      </div>
      <h2 className="text-2xl font-bold tracking-tight text-foreground mb-2">
        {featureName}
      </h2>
      <p className="text-muted-foreground max-w-md mb-1">Coming Soon</p>
      {description && (
        <p className="text-sm text-muted-foreground max-w-md mb-8">{description}</p>
      )}
      {!description && <div className="mb-8" />}
      <Button variant="outline" onClick={() => navigate(-1)}>
        <ArrowLeft className="mr-2 h-4 w-4" />
        Go Back
      </Button>
    </div>
  );
}
